export default __webpack_public_path__ + "static/media/dollorBag.bc67a897.svg";